import React from "react";
import UserList from "../component/UserList";

const UserListContainer = () => (<UserList />)

export default UserListContainer;
